import { Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import * as fromRootStore from '../../../store';
import { IAppState, DealerOptionStore, LocalSpecialStore, FeatureConfigStore } from '../../../store/index';
//
// Library Model/Services
//
import { ddDealerOptionService } from './dd-dealer-option.service';
import { ddLocalSpecialService } from './dd-local-special.service';
import { ddProtectionProductsService } from './dd-protection-products.service';
import { Store } from '@ngrx/store';
import { isNil, uniqBy } from 'lodash';
import { DealerOption } from '../../../../lib/angular/model/dealer/dealer-option';
import { SpecialOffer } from '../../../../lib/angular/model/dealer/special-offer/special-offer';
import { FeatureConfig } from '../../../../lib/angular/model/dealer/feature-config';
import * as Library from '../../../../lib/core/library/index';
import { LocalSpecialActionSet } from '../../../store/actions/local-special.action';
import {
    MenuActionEnableAccessories,
    MenuActionEnableProtectionProducts,
    MenuActionEnableLocalSpecial,
    MenuActionEnableDetaiMenuItems
} from '../../../store/actions/menu.action';
import { DealerOptionActionSet } from '../../../store/actions/dealer-option.action';

import { DDFeatureConfigService } from './dd-feature-config.service';
import { FeatureConfigActionLoad, FeatureConfigActionSet } from '../../../store/actions/feature-config.action';
import { ProtectionProductsActionSet } from '../../../store/actions/protection-products.action';

//
// App Service(s)
//
import { ddHttpService } from '../dd-HttpService';

@Injectable()
export class DDMenuEnableDisableService implements OnInit {

    public dealerOptions: DealerOption[];
    public localSpecials: SpecialOffer[];
    public featureConfig: FeatureConfig[];
    /**
    * Function: constructor()
    */
    constructor(
        private _dealerOptionService: ddDealerOptionService,
        private _localSpecialService: ddLocalSpecialService,
        private _ddProtectionProductsService: ddProtectionProductsService,
        private _store: Store<fromRootStore.IAppState>,
        private _FeatureConfigService: DDFeatureConfigService,
    ) {

    }

    ngOnInit() {
        //
        // Listen for DealerOptionStore
        //
        this._store.select(DealerOptionStore).subscribe(data => {
            if (data.hasItems) {
                const localSpecialsData = Object.assign({}, data.items);
                // Load ALL Accessories
                // ::SDL
                this.dealerOptions = uniqBy(localSpecialsData, (o) => {
                    return `${o.productId}${o.subcategoryId}`;
                });
            } else {
                this.dealerOptions = null;
            }
        });

        //
        // Listen for LocalSpecialStore
        //
        this._store.select(LocalSpecialStore).subscribe(data => {
            if (data.hasItems) {
                this.localSpecials = Object.assign({}, data.items);
            } else {
                this.localSpecials = null;
            }
        });


        this._store.select(fromRootStore.FeatureConfigStore).subscribe(data => {
            if (data.hasItems) {
                this.featureConfig = Object.assign({}, data.items);
            } else {
                this.featureConfig = null;
            }
        });
    }

    //
    // Load Dealer Options and Local Specials
    //
    loadDealerOptions(vehicleDetails: any) {
        if (!Library.isArrayWithLength(this.dealerOptions)) {
            if (!isNil(vehicleDetails)) {
                //
                // Attempt to Get Dealer Options Information
                // ::SDL
                if (!isNil(vehicleDetails.marketingSeries)) {
                    vehicleDetails.marketingSeries = vehicleDetails.marketingSeries.toUpperCase();
                    if (vehicleDetails.marketingSeries.toLowerCase().indexOf('c&#8209;hr') !== -1
                        || vehicleDetails.marketingSeries.toLowerCase().indexOf('‑') !== -1) {
                            vehicleDetails.marketingSeries = vehicleDetails.marketingSeries.replace('&#8209;', '-');
                            vehicleDetails.marketingSeries = vehicleDetails.marketingSeries.replace('‑', '-');
                    }
                }
                const marketingSeries = vehicleDetails.marketingSeries
                    .replace('<I>', '').replace('<i>', '')
                    .replace('</I>', '').replace('</i>', '');

                this._dealerOptionService.get(vehicleDetails.dealerCd, {
                    modelYear: vehicleDetails.year,
                    series: marketingSeries,
                    modelCode: vehicleDetails.model.modelCd
                })
                    .subscribe(resp => {
                        //
                        // Enable Accessories if we where able to get accessories
                        //
                        this._store.dispatch(new MenuActionEnableAccessories(resp.hasData()));
                        //
                        // If we have data
                        //
                        if (resp.hasData()) {
                            //
                            // Persist the Dealer Option Information
                            //
                            this._store.dispatch(new DealerOptionActionSet(resp.data));
                        }
                    });
            }
        } else {
            this._store.dispatch(new MenuActionEnableAccessories(Library.isArrayWithLength(this.dealerOptions)));
        }
    }

    loadLocalSpecials(vehicleDetails: any) {
        if (!Library.isArrayWithLength(this.localSpecials)) {
            if (!isNil(vehicleDetails)) {
                //
                // Attempt to Get Local Specials Information
                // ::SDL
                this._localSpecialService.get({
                    zipCode: '63141',
                    // series: this.vehicleDetails.seriesCode,
                    // year: this.vehicleDetails.seriesCode,
                    // key: this.vehicleDetails.seriesCode,
                    series: 'camry',
                    year: '2018',
                    key: '8C5D3B22DD3D9FE7EEE6BF76CBADB4A9'
                })
                    .subscribe(resp => {
                        //
                        // Enable Local Specials if we were able to get local specials
                        //
                        this._store.dispatch(new MenuActionEnableLocalSpecial(resp.hasData()));
                        //
                        // If we have data
                        //
                        if (resp.hasData()) {
                            //
                            // Persist the Local Special Information
                            //
                            this._store.dispatch(new LocalSpecialActionSet(resp.data));
                        }
                    });
            }
        } else {
            this._store.dispatch(new MenuActionEnableLocalSpecial(Library.isArrayWithLength(this.loadLocalSpecials)));
        }
    }

    loadOptionsAndSpecials(vehicleDetails: any) {
        // To show detail menu
        this._store.dispatch(new MenuActionEnableDetaiMenuItems({
            hidden: false,
            routerLink: 'Detail'
        }));
        this.loadDealerOptions(vehicleDetails);
        // this.loadLocalSpecials(vehicleDetails);
    }

    loadFeatureConfigData(vehicleDetails: any) {
        if (!Library.isArrayWithLength(this.featureConfig)) {
            if (!isNil(vehicleDetails)) {
                this._FeatureConfigService
                    .get(vehicleDetails.dealerCd, null)
                    .subscribe(resp => {
                        if (resp.hasData()) {
                            this._store.dispatch(new FeatureConfigActionSet(resp.data));
                        }
                        this.loadOptionsAndSpecials(vehicleDetails);
                    });
            }
        } else {
            this.loadOptionsAndSpecials(vehicleDetails);
        }
    }

    loadProtectionProducts(sharedData: any) {
        if (sharedData.token && sharedData.tfsFinancingArray.length > 0) {
            this._ddProtectionProductsService.getProtectionProducts(sharedData.dealerDetails.dealerCode)
                .subscribe((res => {
                    if (!isNil(res)) {
                        this._store.dispatch(new ProtectionProductsActionSet(res));
                        this._store.dispatch(new MenuActionEnableProtectionProducts(true));
                    } else {

                    }
                }), e => {
                    // console.log(e);
                });
            }
    }
}
